import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_ORGANIZATION_NAME } from './orgDetailsBreadcrumb.query';

export { FETCH_ORGANIZATION_NAME } from './orgDetailsBreadcrumb.query';

export const OrgDetailsBreadcrumb = () => {
  const { translateBackendString } = useLocalization();
  const { id } = useParams();
  const { data } = useQuery(FETCH_ORGANIZATION_NAME, { variables: { id } });

  return data
    ? translateBackendString(data.fetchOrganization.organization.translatedName)
    : id;
};
